<template>
  <div :class="wrapClasses">
    <div :class="[prefixCls + '-content']">
      <div :class="[prefixCls + '-index']">
        {{ stepNumber }}
      </div>
      <div :class="[prefixCls + '-title']">{{ title }}</div>
    </div>
    <div :class="[prefixCls + '-tail']"><i></i></div>
  </div>
</template>

<script>
const prefixCls = "gy-steps";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      prefixCls,
      stepNumber: "",
      currentStatus: "",
    };
  },
  computed: {
    wrapClasses() {
      return [`${prefixCls}-item`, `${prefixCls}-status-${this.currentStatus}`];
    },
  },
};
</script>

<style lang="less">
.gy-steps {
  &-item {
    display: flex;
    position: relative;
    vertical-align: top;
    flex: 1;
    overflow: hidden;
    &:last-child {
      flex: none;
    }
  }
  &-item:last-child &-tail {
    display: none;
  }
  &-tail {
    flex: 1;
    > i {
      display: inline-block;
      width: 100%;
      height: 1px;
      background-color: red;
      border-radius: 1px;
      &:after {
        content: "";
        width: 0;
        height: 100%;
        background: red;
        opacity: 0;
        position: absolute;
        top: 0;
      }
    }
  }
  &-content {
    display: inline-block;
    text-align: center;
  }
  &-index {
    display: inline-block;
    text-align: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    margin-bottom: 10px;
    color: #ffffff;
  }
  &-status-finish {
    .gy-steps-index {
      background-color: #35a8a4;
    }
    .gy-steps-title {
      color: #35a8a4;
    }
    .gy-steps-tail {
      > i {
        background-color: #35a8a4;
      }
    }
  }
  &-status-process {
    .gy-steps-index {
      background-color: #35a8a4;
    }
    .gy-steps-title {
      color: #35a8a4;
    }
    .gy-steps-tail {
      > i {
        background-color: #eeeeee;
      }
    }
  }
  &-status-wait {
    .gy-steps-index {
      background-color: #eeeeee;
    }
    .gy-steps-title {
      color: #eeeeee;
    }
    .gy-steps-tail {
      > i {
        background-color: #eeeeee;
      }
    }
  }
}
</style>
